import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import TanqueCheioReportList from './TanqueCheioReportList';

const Reports = ({ embedded = false }) => {
  return (
    <Box
      sx={{
        width: '100%',
        ...(embedded
          ? {}
          : {
              px: { xs: 2, md: 4 },
              py: 2,
            }),
      }}>
      {embedded && (
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#333', mb: 2 }}>
          Relatório Tanque Cheio
        </Typography>
      )}
      <TanqueCheioReportList />
    </Box>
  );
};

Reports.propTypes = {
  embedded: PropTypes.bool,
};

export default Reports;
